/************************************************************************************************
 * Copyright ©, 2018-2020, MapGIS
 * @Description: 服务配置初始化
 * @Author: Chenzilong
 * @History: 1、初始版本 2018-09-26 Chenzilong
 ************************************************************************************************/

import EditableTable from '@/common/components/editableTable';
import GlobalFooter from 'ant-design-pro/lib/GlobalFooter';
import 'ant-design-pro/lib/GlobalFooter/style';
import Result from 'ant-design-pro/lib/Result';
import 'ant-design-pro/lib/Result/style';
import { Button, Icon, InputNumber, message, Modal, Popconfirm, Steps } from 'antd';
import axios from 'axios';
import React from 'react';
import asyncLoader from '../../core/asyncLoader';
import Service from '../../core/service';
import style from './index.less';

const Step = Steps.Step;
const logo = "/static/images/logo/mapgis.png";

class InitializePage extends React.Component {
    constructor(props) {
        super(props);
        const servers = props.servers.map((s, i) => ({ ...s, key: ++i }));
        this.state = { servers, loading: false, current: 0, expiration: props.expiration };
    }

    onDelete = (record) => {
        const servers = this.state.servers.filter(s => s.key != record.key).map((s, index) => ({ ...s, key: index + 1 }));
        this.setState({ servers });
    }

    handleSave = (record) => {
        let servers = this.state.servers.concat();
        const index = servers.findIndex(s => s.key == record.key);
        servers.splice(index, 1, record);
        this.setState({ servers });
    }

    onAdd = (e) => {
        const { servers } = this.state;
        this.setState({ servers: [...servers, { key: servers.length + 1 }] });
    }

    onSave = async (e) => {
        const { servers, expiration } = this.state;
        const hasValidConfig = servers.some(s => (s.cityServer && s.fileServer && s.gisServer));
        if (hasValidConfig) {
            this.setState({ loading: true });
            try {
                const jsonString = JSON.stringify({
                    initialized: 1,
                    servers: servers,
                    expiration
                });
                const { data: { success, message: msg } } = await axios.get("/handler/config.ashx", { params: { json: jsonString } });
                if (success) {
                    const { success } = await Service.init();
                    if (success) {
                        // const { data: { success, message: msg } } = await Service.City.Plugin("OMS").get("S_ChangeSolution", { params: { solution: "_default_" } });
                        // if (success) {
                        this.onNext();
                        // } else {
                        //     message.error(msg || "切换解决方案失败");
                        // }
                    } else {
                        message.error("保存配置失败")
                    }
                } else {
                    message.error(msg || "保存配置失败");
                }
            } catch (e) {
                console.error(e);
                message.error("保存配置失败");
            } finally {
                this.setState({ loading: false });
            }
        } else {
            message.error("请填写有效配置，至少需要一项");
        }
    }

    onDBSave = async (e) => {
        try {
            this.setState({ loading: true });
            //查询当前客户端的配置信息用于测试数据库是否正常
            const { status } = await Service.City.Plugin("services").get("SystemConfig", {
                params: {
                    client: this.props.client,
                    _ts: Date.now()
                },
                timeout: 10000
            });
            this.setState({ loading: false });
            if (200 == status || 304 == status) {
                this.onNext();
            } else {
                message.error("运维数据库无法连接/数据库版本与客户端不匹配");
            }
        } catch (e) {
            this.setState({ loading: false });
            message.error("运维数据库无法连接/数据库版本与客户端不匹配");
        }
    }

    onPrev = (e) => {
        const current = this.state.current - 1;
        this.setState({ current });
    }

    onNext = (e) => {
        const current = this.state.current + 1;
        this.setState({ current });
    }

    onStart = (e) => {
        location.replace(location.origin + location.pathname);
    }

    onHelp = (e) => {
        Modal.info({
            title: "配置说明",
            width: 600,
            content: (
                <div>
                    <b>1、客户端域名</b>
                    <p>请填入客户端<b>域名</b>，例如：'http://192.168.12.12:8080'</p>
                    <p>此域名用于同时发布内外网的情况，客户端在发请求前进行服务地址匹配时使用。<font style={{ color: 'red' }}>若客户端只做单网发布（只有一项配置时），此处可缺省不填</font></p>
                    <b>2、服务器配置</b>
                    <p>请填入各服务器<b>发布目录地址</b>，例如：'/Cityinterface'(与客户端域名相同时)，'http://192.168.12.12:8090/Cityinterface'(指定域名) </p>
                    <b>3、内外网发布</b>
                    <p>同一客户端同时进行内外网发布时，请添加<b>两项配置</b>分别对应内网、外网。此时客户端域名不可缺省，请填写完整的域名</p>
                    <p>请将内网配置放在<b>第一项</b>，这样可保证在发布客户端的服务器上进行本地访问（localhost，127.0.0.1）有效</p>
                </div>
            )
        });
    }

    render() {
        const columns = [{
            title: '#',
            dataIndex: 'key'
        }, {
            title: '客户端域名',
            dataIndex: 'origin',
            width: "20%",
            editable: true,
            className: "editable",
            handleSave: this.handleSave
        }, {
            title: '业务服务器',
            dataIndex: 'cityServer',
            width: "20%",
            editable: true,
            className: "editable",
            handleSave: this.handleSave
        }, {
            title: 'GIS服务器',
            dataIndex: 'gisServer',
            width: "20%",
            editable: true,
            className: "editable",
            handleSave: this.handleSave
        }, {
            title: '文件服务器',
            dataIndex: 'fileServer',
            width: "20%",
            editable: true,
            className: "editable",
            handleSave: this.handleSave
        }, {
            title: '消息服务器',
            dataIndex: 'wsServer',
            width: "20%",
            editable: true,
            className: "editable",
            handleSave: this.handleSave
        }, {
            title: '操作',
            render: (text, record) => (
                <span>
                    <Popconfirm title="确认删除？" onConfirm={this.onDelete.bind(this, record)} okText="是" cancelText="否">
                        <a btn='1' style={{ whiteSpace: "nowrap" }}>删除</a>
                    </Popconfirm>
                </span>
            )
        }];
        const steps = ["欢迎", "服务器配置", "数据库配置", "开始使用"];
        const { servers, loading, current, expiration } = this.state;
        const thisYear = (new Date()).getFullYear();
        let databaseComp = null;
        if (current == 2) {
            const Database = asyncLoader(() => import('@/cityoms/components/database'));
            databaseComp = <Database headStyle={{ display: "none" }} style={{ border: "none", background: "transparent" }} />;
        }
        return (
            <div className={style.page}>
                <div className={style.header}>
                    <img src={logo} style={{ width: "200px" }} />
                </div>
                <Steps current={current} className={style.steps}>
                    {steps.map(item => <Step key={item} title={item} />)}
                </Steps>
                <div className={style.stepsContent}>
                    {
                        current == 0 && (
                            <Result title="欢迎使用中地数码市政事业部产品"
                                description="当前网站未进行初始化配置，点击<下一步>进行服务器配置，完成配置后即可使用" />
                        )
                    }
                    {
                        current == 1 && (
                            <div>
                                <div className={style.actions}><a btn='1' onClick={this.onHelp}>配置说明 <Icon type="question-circle" /></a><Button shape="circle" icon="plus" onClick={this.onAdd} title="添加配置" size="small" /></div>
                                <EditableTable dataSource={servers} columns={columns} pagination={false} />
                                <br />
                                <span>token过期时间：<InputNumber min={1} value={expiration} onChange={(expiration) => this.setState({ expiration })} /> 小时</span>
                            </div>
                        )
                    }
                    {
                        current == 2 && (
                            <div>
                                {databaseComp}
                            </div>
                        )
                    }
                    {
                        current == 3 && (
                            <Result type="success"
                                title="配置完成"
                                description="已完成所有配置，点击<开始使用>或使用浏览器刷新本页面进入系统"
                                actions={
                                    <div>
                                        <Button type="primary" onClick={this.onStart}>开始使用</Button>
                                    </div>
                                } />
                        )
                    }
                </div>
                <div className={current == 0 ? style.flexEnd : style.stepsAction}>
                    {
                        current == 0
                        && (
                            <Button type="primary" onClick={this.onNext} style={{ justifySelf: "flex-end" }}>下一步<Icon type="right" /></Button>
                        )
                    }
                    {
                        (current == 1 || current == 2)
                        && (
                            <Button onClick={this.onPrev}><Icon type="left" />上一步</Button>
                        )
                    }
                    {
                        current == 1
                        && (
                            <span>
                                <Button style={{ marginRight: 10 }} disabled={loading} onClick={this.onNext}>跳过</Button>
                                <Button type="primary" disabled={loading} onClick={this.onSave}>下一步{loading ? <Icon type="loading" /> : <Icon type="right" />}</Button>
                            </span>
                        )
                    }
                    {
                        current == 2
                        && (
                            <Button type="primary" disabled={loading} onClick={this.onDBSave}>下一步{loading ? <Icon type="loading" /> : <Icon type="right" />}</Button>
                        )
                    }
                </div>
                <GlobalFooter className={style.footer} copyright={<div>Copyright <Icon type="copyright" /> {thisYear} 武汉中地数码科技有限公司出品</div>} />
            </div>
        );
    }
}

export default InitializePage;